import { render, staticRenderFns } from "./AcademyHome.vue?vue&type=template&id=f0338238&scoped=true"
import script from "./AcademyHome.vue?vue&type=script&lang=js"
export * from "./AcademyHome.vue?vue&type=script&lang=js"
import style0 from "./AcademyHome.vue?vue&type=style&index=0&id=f0338238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0338238",
  null
  
)

export default component.exports